import { getPayableAmounts } from "@msuite/utils/incoming-invoices";
import type { IncomingInvoiceReviewFormSchema } from "@msuite/utils/schemas";

/**
 * The net amount the review's cost allocation adds up to: the reduced one while the Kürzung is
 * switched on and lowers the printed amount, the printed one otherwise.
 *
 * @param printedNetAmount - The net amount read off the invoice.
 * @param values - The Kürzung as the form holds it.
 * @returns The payable net amount, zero when the invoice carries none.
 */
export function getReviewNetAmount(
	printedNetAmount: number | null,
	values: Pick<IncomingInvoiceReviewFormSchema, "isReduced" | "reducedNetAmount">,
) {
	const payable = getPayableAmounts({
		netAmount: printedNetAmount,
		vatAmount: null,
		grossAmount: null,
		reducedNetAmount: values.isReduced ? values.reducedNetAmount : null,
	});
	return payable.netAmount ?? 0;
}
